import apiClient from '@/services/AccountClient'
import { HEADER_SKIP_AUTOEXTEND } from '@/services/ApiClient/ApiClient'

export default {
  fetchAll (params = {}, options) {
    const defaultSort = 'updatedAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/payment-orders',
      {
        ...params,
        sort: [].concat(params.sort, defaultSort)
      },
      options
    )
  },
  fetchById (id, params = {}) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/payment-orders/${id}`,
      params
    )
  },
  fetchTotalCount (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/payment-orders/count',
      params,
      {
        headers: { [HEADER_SKIP_AUTOEXTEND]: true },
        ...options
      }
    )
  },
  createInternal (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/payment-orders/internal',
      data
    )
  },
  createTopup (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/payment-orders/topup',
      data
    )
  },
  createWithdrawal (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/payment-orders/withdrawal',
      data
    )
  },
  createForexConversion (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/payment-orders/forex',
      data
    )
  },
  verify (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payment-orders/${id}/verify`
    )
  },
  cancel (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payment-orders/${id}/cancel`
    )
  }
}
